/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import {
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormMessage,
} from "@/shared/components/ui/form";
import { Checkbox } from "@/shared/components/ui/checkbox";
import { BaseFieldProps } from "./form-field-utils";
import { FormFieldLabel } from "./form-field-label";

export function FieldCheckbox({ name, label, description, className, labelType = "text", tooltipContent }: BaseFieldProps) {
    return (
        <FormField
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    <div className="flex items-center gap-2">
                        <FormFieldLabel label={label} labelType={labelType} tooltipContent={tooltipContent} />
                        <FormControl>
                            <Checkbox ref={field.ref} checked={!!field.value} onCheckedChange={field.onChange} />
                        </FormControl>
                    </div>
                    {description && <FormDescription>{description}</FormDescription>}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
